import axios from 'axios'
export default {
  namespaced: true,
  state: {
    campaignListPageNumber: 1,
    campaignListKeyword: '',
    campaignInfo: {},
    sowList: [],
    sowInfo: {},
    sowProcess: []
  },
  mutations: {
    setDefaultSowInfo (state) {
      if (state.sowList.length > 2) {
        state.sowInfo = {
          sub_final_scope_name: '',
          is_storage: state.sowList[1].is_storage,
          vendor_name: state.sowList[1].vendor_name,
          vendor_id: state.sowList[1].vendor_id,
          spotplan_download_path: '',
          spotplan_name: '',
          spotplan_path: '',
          remark: ''
        }
      } else {
        state.sowInfo = {
          sub_final_scope_name: '',
          is_storage: null,
          vendor_name: '',
          vendor_id: null,
          spotplan_download_path: '',
          spotplan_name: '',
          spotplan_path: '',
          remark: ''
        }
      }
    },
    setDefaultSowProcess (state) {
      state.sowProcess = [
        {
          action: 'sow-info',
          can_view: true,
          task_name: '新建执行项目',
          status: '进行中'
        },
        {
          action: 'procurement-confirm-quotation',
          can_view: false,
          task_name: '确定报价',
          status: '等待中'
        },
        {
          action: 'marketing-upload-sow-contract-and-do',
          can_view: false,
          task_name: '合同DO',
          status: '等待中'
        }
      ]
    },
    setCampaignInfo (state, val) {
      state.campaignInfo = val
    },
    setCampaignListPageNumber (state, val) {
      state.campaignListPageNumber = val
    },
    setCampaignListKeyword (state, val) {
      state.campaignListKeyword = val
    },
    setSOWInfo (state, val) {
      state.sowInfo = val
    },
    setSOWList (state, val) {
      state.sowList = val
    },
    setSowProcess (state, val) {
      state.sowProcess = val
    }
  },
  actions: {
    async getCampaignInfo (context, campaignId) {
      let res = await axios.get('/management/star/getCampaignOverview', {
        params: {
          campaign_id: campaignId || context.state.campaignInfo.campaign_id
        }
      })
      context.commit('setCampaignInfo', res)
      return res
    },
    async getSOWList (context, setSowInfo) {
      let res = await axios.get('/management/star/getSowList', {
        params: {
          campaign_id: context.state.campaignInfo.campaign_id
        }
      })
      context.commit('setSOWList', res)
      if (setSowInfo) {
        context.commit('setSOWInfo', res[0])
      }
      return res
    },
    async getSOWInfo (context, id) {
      let res = await axios.get('/management/star/getSowInfo', {
        params: {
          sub_final_scope_id: id || context.state.sowInfo.sub_final_scope_id
        }
      })
      context.commit('setSOWInfo', res)
      return res
    },
    async getProcessTasks (context, params) {
      let res = await axios.get('/common/getProcessTasks', {
        params
      })
      if (res.StarExecution) {
        context.commit('setSowProcess', res.StarExecution)
      } else {
        context.commit('setSowProcess', res.StarOrder)
      }
      return res
    }
  }
}
